import * as types from '../types'

// 变量名
const defaultState = {
  loading: false
}

/**
 * loading加载动画 reducer
 * state: 默认值为defaultState
 * action：调用时需要传的参数
 * */
export default function loading(state = defaultState, action = {}) {
  const { 
    type,     // 调用时传的方法名
    payload     // 调用时传的参数
  } = action
  const res = Object.assign({}, state)
  switch (type) {
    // loading方法
    case types.LOADING:
      res.loading = payload.loading
      break
    
    default:

  }
  return res
}